<template>
	<div class="promoter-order" ref="container">
		<div class="promoter-header">
			<div class="search acea-row row-between-wrapper">
				<form @submit.prevent="submitForm">
					<div class="input">
						<input placeholder="搜索" v-model="whereli.keyword" @keyup="keywordkeyup" />
						<span v-if="isclose" @click="closesearch" class="iconfont icon-guanbi"></span>
						<div @click="submitForm" class="iconfont icon-sousuo2"></div>
					</div>
				</form>
			</div>
			<div class="statistical-page">
				<div class="navs">
					<div class="list">
						<div class="item" :class="time == 'total' ? 'on' : ''" @click="setTime('total')">
							全部
						</div>
						<div class="item" :class="time == 'today' ? 'on' : ''" @click="setTime('today')">
							今天
						</div>
						<div class="item" :class="time == 'yesterday' ? 'on' : ''" @click="setTime('yesterday')">
							昨天
						</div>
						<div class="item" :class="time == 'seven' ? 'on' : ''" @click="setTime('seven')">
							最近7天
						</div>
						<!-- <div
		        class="item"
		        :class="time == 'month' ? 'on' : ''"
		        @click="setTime('month')"
		      >
		        本月
		      </div> -->
						<div class="item" :class="time == 'date' ? 'on' : ''" @click="dateTitle">
							<!-- <span class="iconfont icon-xiangxia"></span>
		        <span v-for="(value, index) in renderValues" :key="index">
		          {{ value }}</span
		        > -->
							自定义
						</div>
					</div>
				</div>
				<div class="calendar-wrapper" :class="current === true ? 'on' : ''">
					<div class="calendar">
						<Calendar :clean="clean" :lunar="lunar" ref="calendar" :range="isrange" :multi="ismulti"
							@select="select" @next="next" @prev="prev" :value="value" :weekSwitch="weekSwitch"
							:monthRange="monthRange" rangeMonthFormat="yyyy年MM月" monFirst responsive
							:begin="[1992, 5, 20]" :end="[2049, 5, 20]" />
					</div>
				</div>
				<div class="mask" @touchmove.prevent v-show="current === true" @click="close"></div>
			</div>
		</div>
		<div v-if="list.length > 0">
			<div class="total-ordernum">
				<p>共<strong>{{ count }}</strong>订单</p>
				<p>共获得商品佣金<strong>{{ commissionCount }}</strong>元</p>
			</div>

			<div class="list productlist">
				<div class="item" v-for="(item, index) in list" :key="index">
					<div class="listn">
						<div class="itenm">

							<div class="row-top">
								<p>买家：{{ item.nickname }}<span>{{ item.status }}</span></p>
								<p class="row-top-time">
									订单号：{{ item.order_id }}
									<span class="copy copy-data" :data-clipboard-text="item.order_id">复制</span>
								</p>
								<p class="row-top-time">下单时间：{{ item.time }}</p>
							</div>
							<div class="row-center" v-for="(val, indexn) in item.goodsinfo" :key="indexn">
								<div class="row-center-img"><img :src="val.cart_info.productInfo.image" alt=""></div>
								<div class="row-center-book">
									<p class="row-center-book-name">{{ val.cart_info.productInfo.store_name }}</p>
									<p class="row-center-book-num">×{{ val.cart_info.cart_num }}</p>
									<div class="row-center-book-brokerage-box">
										<p v-if="item.number.brokerage_discount" class="row-center-book-brokerage">
											商品佣金比例：{{ val.discount }}% <strong>￥{{ val.commission }}</strong></p>
										<p v-if="item.number.brokerage" class="row-center-book-brokerage">商品佣金比例：{{
					val.discount }}%</p>
										<p v-if="item.number.brokerage_service" class="row-center-book-brokerage">
											邀请佣金比例：{{ val.discount_invited }}%</p>
										<p v-if="item.number.brokerage_invited" class="row-center-book-brokerage">
											服务佣金比例：{{ val.discount_service }}%</p>
									</div>

								</div>
							</div>
							<div class="">
								<div style="display: flex;justify-content: space-between;">
									<p class="order_type price">{{ item.order_type }}</p>
									<div class="row-bottom-price price">
										<p style="text-align: right;">总佣金：<strong>￥{{ item.number.total }}</strong></p>
										<p>订单总价：<strong>￥{{ item.total_price }}</strong></p>
									</div>
								</div>
								<p class="font-color-gray price" style="float: right;">{{ item.status_name }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="no-order">暂无订单</div>
		<Loading :loaded="loaded" :loading="loading"></Loading>
	</div>
</template>
<script>
import Calendar from "mpvue-calendar";
import "mpvue-calendar/src/browser-style.css";
import { getStatisticsMonth, getStatisticsTime } from "../../../api/admin";
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;
const day = new Date().getDate();
import { getSpreadOrder } from "../../../api/user";
import Loading from "@components/Loading";
import ClipboardJS from "clipboard";
export default {
	name: "PromoterOrder",
	components: {
		Loading,
		Calendar
	},
	props: {},
	data: function () {
		return {
			isclose: false,
			list: [],
			whereli: {
				page: 1,
				limit: 15,
				time: 0,
				keyword: ""
			},
			loaded: false,
			loading: false,
			count: "",
			commissionCount: "",
			value: [[year, month, day - 1], [year, month, day]],
			isrange: true,
			weekSwitch: false,
			ismulti: false,
			monFirst: true,
			clean: false, //简洁模式
			lunar: false, //显示农历
			renderValues: [],
			monthRange: [],
			current: false,
			where: {
				start: "",
				stop: "",
				type: ""
			},
			time: "", //时间|today=今天|yesterday=昨天|month=本月
			title: "", //时间|today=今天|yesterday=昨天|month=本月
		};
	},
	watch: {
		"$route.params": function (newVal) {
			var that = this;
			if (newVal != undefined) {
				// that.setType(newVal.type);
				that.setTime(newVal.time);
				that.getIndex();
			}
		}
	},
	mounted: function () {
		this.handelRenderValues();
		this.setTime(this.$route.params.time);
		// this.setType(this.$route.params.type);
		this.getIndex();
		this.$scroll(this.$refs.container, () => {
			!this.loading && this.getIndex();
		});
	},
	computed: {
		monthRangeText() {
			return this.monthRange.length ? "固定" : "指定范围";
		}
	},
	methods: {
		// 搜索
		submitForm: function () {
			this.whereli.page = 1;
			this.loaded = false;
			this.loading = false;
			this.list = [];
			this.getIndex();
		},
		keywordkeyup: function () {
			this.isclose = true;
		},
		closesearch: function () {
			this.whereli.keyword = "";
			this.submitForm();
			this.isclose = false;
		},
		getIndex: function () {
			let there = this;
			if (there.loaded == true || there.loading == true) return;
			there.loading = true;
			getSpreadOrder(there.whereli).then(
				res => {
					console.log(res, 'res1212');
					there.loading = false;
					there.loaded = res.data.list.length < there.whereli.limit;
					there.whereli.page = there.whereli.page + 1;
					there.list.push.apply(there.list, res.data.list);
					there.count = res.data.count;
					there.commissionCount = res.data.commissionCount;
					this.$nextTick(function () {
						let copybtn = document.getElementsByClassName("copy-data");
						const clipboard = new ClipboardJS(copybtn);
						clipboard.on("success", () => {
							this.$dialog.success("复制成功");
						});
					});
				},
				error => {
					there.$dialog.message(error.msg);
					setTimeout(function () {
						there.$router.push('/');
					}, 1000);
				},
				300
			);
		},
		setTime: function (time) {
			this.time = time;
			var year = new Date().getFullYear(),
				month = new Date().getMonth() + 1,
				day = new Date().getDate();
			switch (time) {
				case "total":
					this.where.start =
						new Date(Date.parse(2020 + "/" + 1 + "/" + 1)).getTime() /
						1000;
					this.where.stop =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000 +
						24 * 60 * 60 -
						1;
					this.title = "全部";
					this.whereli.time = 0;
					this.whereli.page = 1;
					this.loaded = false;
					this.loading = false;
					this.list = [];
					this.getIndex();
					break;
				case "today":
					this.where.start =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000;
					this.where.stop =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000 +
						24 * 60 * 60 -
						1;
					this.title = "今日";
					this.whereli.time = "today";
					this.whereli.page = 1;
					this.loaded = false;
					this.loading = false;
					this.list = [];
					this.getIndex();
					break;
				case "yesterday":
					this.where.start =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000 -
						24 * 60 * 60;
					this.where.stop =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000 -
						1;
					this.title = "昨日";
					this.whereli.time = "yesterday";
					this.whereli.page = 1;
					this.loaded = false;
					this.loading = false;
					this.list = [];
					this.getIndex();
					break;
				// case "month":
				//   this.where.start =
				//     new Date(year, new Date().getMonth(), 1).getTime() / 1000;
				//   this.where.stop = new Date(year, month, 1).getTime() / 1000 - 1;
				//   this.title = "本月";
				//   // this.getIndex();
				//   break;
				case "seven":
					this.where.start =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000 +
						24 * 60 * 60 -
						7 * 3600 * 24;
					this.where.stop =
						new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
						1000 +
						24 * 60 * 60 -
						1;
					this.title = "七日";
					this.whereli.time = "lately7";
					this.whereli.page = 1;
					this.loaded = false;
					this.loading = false;
					this.list = [];
					this.getIndex();
					break;
			}
		},
		// setType: function(type) {
		//   switch (type) {
		//     case "1":
		//       this.where.type = 1;
		//       break;
		//     case "2":
		//       this.where.type = 2;
		//       break;
		//   }
		// },
		clickSomeThing(data) {
			console.log(data);
			this.value = [[2019, 4, 1], [2019, 4, 8]];
		},
		setMonthRange() {
			this.monthRange = this.monthRange.length ? [] : ["2019-4", "2020-1"];
		},
		switchMode() {
			this.weekSwitch = !this.weekSwitch;
			setTimeout(() => {
				this.$refs.calendar.renderer(2019, 1); //渲染2018年8月份
			}, 0);
		},
		handelRenderValues(data) {
			if (this.ismulti) {
				this.renderValues = this.value.map(v => v.join("-"));
			} else if (this.isrange) {
				const values = [];
				data || this.value;
				this.value.forEach((v, i) => {
					values.push(v.join("-"));
					if (!i) {
						values.push("~");
					}
				});
				this.renderValues = values;
			} else {
				this.renderValues = [this.value.join("-")];
			}
		},
		multiMode() {
			this.ismulti = true;
			this.isrange = false;
			this.value = [[year, month, 16], [year, month, 18]];
			this.handelRenderValues();
			this.$refs.calendar.renderer(year, month);
		},
		rangeMode() {
			this.ismulti = false;
			this.isrange = true;
			this.value = [[year, month, 16], [year, month, 22]];
			this.handelRenderValues();
			this.$refs.calendar.renderer(year, month);
		},
		valueMode() {
			this.ismulti = false;
			this.isrange = false;
			this.value = [year, month, 16];
			this.handelRenderValues();
			this.$refs.calendar.renderer(year, month);
		},
		selectMonth(month, year) {
			console.log(year, month);
		},
		prev(y, m, w) {
			console.log(y, m, w);
		},
		next(year, month, week) {
			console.log(year, month, week);
		},
		selectYear(year) {
			console.log(year);
		},
		setToday() {
			this.$refs.calendar.setToday();
		},
		dateInfo() {
			const info = this.$refs.calendar.dateInfo(2018, 8, 23);
			console.log(info);
		},
		renderer() {
			if (this.monthRange.length) {
				this.monthRange = ["2018-8", "2018-8"];
			}
			this.$refs.calendar.renderer(2018, 8); //渲染2018年8月份
		},
		select(val, val2) {
			if (this.isrange) {
				this.handelRenderValues([val, val2]);
			} else if (this.ismulti) {
				this.handelRenderValues(val);
			} else {
				this.handelRenderValues([val]);
			}
			if (
				this.where.start != new Date(val) / 1000 ||
				this.where.stop != new Date(val2) / 1000 + 24 * 60 * 60 - 1
			) {
				this.time = "date";
				this.title = "";
				this.where.start =
					new Date(Date.parse(val[0] + "/" + val[1] + "/" + val[2])).getTime() /
					1000;
				this.where.stop =
					new Date(
						Date.parse(val2[0] + "/" + val2[1] + "/" + val2[2])
					).getTime() /
					1000 +
					24 * 60 * 60 -
					1;
				this.whereli.time = val[0] + '-' + val[1] + '-' + val[2] + ' - ' + val2[0] + '-' + val2[1] + '-' + val2[2];
				this.whereli.page = 1;
				this.loaded = false;
				this.loading = false;
				this.list = [];
				this.getIndex();
			}
		},
		dateTitle: function () {
			this.current = true;
		},
		close: function () {
			this.current = false;
		},

	}
};
</script>
<style scoped>
.calendar-wrapper {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 777;
	transform: translate3d(0, 100%, 0);
	transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}

.calendar-wrapper.on {
	transform: translate3d(0, 0, 0);
}

.statistical-page .wrapper .increase {
	font-size: 0.26rem;
}

.statistical-page .wrapper .increase .iconfont {
	margin-left: 0;
}

.hide {
	display: none;
}

.show {
	display: block;
}

.promoter-order .list .item .listn .itenm .top {
	height: auto;
	padding-top: 0.2rem;
	padding-bottom: 0.2rem;
	margin-left: 0;
	padding-left: 0.3rem;
}

.money_type {
	display: inline-block;
	width: 1.4rem;
	text-align: right;
	color: #777;
}

.money_num {
	color: #ff4d3f;
}

.promoter-header {
	background-color: #fff;
	padding: 0.2rem;
	box-shadow: 0 0 5px #ccc;
	height: 1.8rem;
}

.search form {
	width: 100%;
}

.promoter-order .search.acea-row.row-between-wrapper {
	align-items: center;
}

.promoter-order .search .input input {
	text-align: left;
	text-indent: 1em;
	width: 6.8rem;
}

.promoter-order .search .input {
	width: 100%;
	height: 0.6rem;
	line-height: 0.6rem;
	border-radius: 0.5rem;
	background-color: #f5f5f5;
	text-align: center;
	position: relative;
}

.promoter-order .search .input .iconfont {
	position: absolute;
	right: 0.28rem;
	color: #999;
	font-size: 0.28rem;
	top: 50%;
	transform: translateY(-50%);
	-webkit-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-o-transform: translateY(-50%);
}

.promoter-order .search .input span.icon-guanbi {
	right: 12%;
}

.statistical-page .navs {
	position: absolute;
	top: 0.8rem;
}

.statistical-page .navs .list {
	display: flex;
	justify-content: space-around;
}

.statistical-page .navs .list .item {
	font-size: 0.28rem;
	margin-top: 0;
	margin-left: 0;
}

.total-ordernum {
	padding: 0.3rem 0.2rem;
}

.total-ordernum p {
	font-size: 0.26rem;
	color: #999;
}

.total-ordernum p strong {
	font-size: 0.28rem;
	color: #333;
}

.list {
	padding: 0 0.2rem;
}

.productlist {
	margin-bottom: 0.2rem;
}

.promoter-order .list .item:first-child {
	margin-top: 0;
}

.promoter-order .list .item {
	margin-top: 0.2rem;
}

.promoter-order .list .item .listn .itenm {
	border-radius: 5px;
	padding: 0.25rem;
	overflow: hidden;
}

.promoter-order .list .item .listn .itenm~.itenm {
	margin-top: 0.2rem;
}

.row-top p {
	font-size: 0.28rem;
}

.row-top p span {
	float: right;
	color: #999;
}

.row-top .row-top-time {
	color: #999;
	font-size: 0.24rem;
}

.row-center {
	margin-top: 0.3rem;
	overflow: hidden;
}

.row-center div {
	float: left;
}

.row-center-img {
	width: 12%;
}

.row-center-img img {
	display: block;
	width: 100%;
}

.row-center-book {
	width: 88%;
}

.row-center-book-name {
	margin-left: 0.2rem;
	width: 100%;
	height: 0.4rem;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.row-center-book-num {
	float: right;
}

.row-center-book-brokerage {
	font-size: 0.26rem;
	color: #999;
}

.row-center-book-brokerage-box {
	margin-top: 0.1rem;
	margin-left: 0.2rem;
}

.row-bottom {
	float: right;
}

.row-bottom p {
	text-align: right;
	margin-top: 0.2rem;
	font-size: 0.26rem;
}

.row-bottom-price strong {
	color: #ff720d;
	font-size: 0.3rem;
}

.row-center-book-brokerage strong {
	color: #ff720d;
	margin-left: .2rem;
}

.no-order {
	text-align: center;
	color: #999;
	margin-top: 0.5rem;
}

.font-color-gray {
	color: #999;
}

.row-top-time .copy-data {
	border: 1px solid #999;
	padding: 0 0.1rem;
	float: none;
	border-radius: 0.05rem;
}

.price {
	margin-top: .2rem;
	font-size: .26rem;
}

.order_type {
	font-weight: 500;
	font-size: .3rem;
}
</style>
